import _ from 'underscore';
import EventsFallback from '../../lib/events_fallback';
import Events from '../../util/eventEmitter.js';

export default class DataTables extends EventsFallback {
  /**
   * @todo Would be nice to replace dataTable's camelCase notation instead of the Hungarian one.
   *    This way we can get rid of parsing the options and improve readability.
   * @see https://datatables.net/upgrade/1.10-convert#Options
   */
  constructor(options) {
    var defaults;

    super();

    /**
     * Internal settings
     */
    this.settings = {
      aoColumnDefs: null,
      bLengthChange: false,
      bProcessing: true,
      bJQueryUI: false,
      editable: false,
      stateSave: true,
      iDisplayLength: 15,
      iDisplayStart: parseInt(cookie.get('currentPage')) * 15 || 0,
      sPaginationType: 'full_numbers',
      // Initialize our jQuery maskPassword() plugin for all elements in the row that have class mask-password
      // Pass className property inside column object in order to take advantage of this feature.
      // @see https://datatables.net/reference/option/columns.className
      createdRow: function (row) {
        $(row).find('.mask-password').maskPassword();
      },
    };

    /**
     * Default external settings
     */
    defaults = {
      fixed: false,
      fixedColumnWidth: 80,
      fixedColumns: 1,
      filter: false,
      searchElem: null, // Allows to customize which element will be used as search field
      searchWhen: null, // Allows to search when a event is triggered
      stateSave: true,
      controller: document.location.pathname.substr(1),
    };

    this.$el = options.el;
    this.options = _.extend({}, defaults, options);
  }

  /**
   * It initializes the DataTables plugin
   */
  start() {
    var parsedSettings;

    if (!this.$el.length) {
      return;
    }

    parsedSettings = this._parseSettings($.extend({}, this.settings));
    this.table = this.$el.dataTable(parsedSettings);

    if (this.options.source) {
      this._initComplete();
    }

    cookie.remove('currentPage');

    $.fn.dataTable.ext.errMode = 'none';
    $('#tab0').on('error.dt', function () {
      window.location.reload(false);
    });

    this.listen();
  }

  listen() {
    if (typeof this.options.onFetch !== 'function') {
      return;
    }
    this.table.on('xhr.dt', (_event, _settings, data) =>
      this.options.onFetch(data),
    );
  }

  /**
   * It destroys the DataTable
   */
  remove() {
    if (this.table) {
      this.table.fnDestroy(true);
    }
    this.$el.remove();
    this.off();
  }

  /**
   * It refreshes datatables
   */
  refresh() {
    this._adjustRowsHeight();
  }

  /**
   * Internal functions
   */
  _parseSettings(settings) {
    var initComplete = this._initComplete.bind(this),
      defaultOptions,
      i;

    settings.aoColumns = this.options.columns;
    settings.bFilter = this.options.filter || this.options.searchElem;

    // If searchElem passed, remove DataTables default search input
    if (this.options.searchElem) {
      settings.sDom =
        "tr<'ui stackable grid'" +
        "<'row rpm pagination'" +
        "<'seven wide column'i>" +
        "<'right aligned nine wide column'p>" +
        '>>';
    }

    if (this.options.searchElem && $(this.options.searchElem).val() !== '') {
      settings.oSearch = { sSearch: $(this.options.searchElem).val() };
    }

    settings.stateSave = this.options.stateSave;
    if (this.options.data) {
      settings.data = this.options.data;
    }
    if (this.options.sorting) {
      settings.aaSorting = this.options.sorting;
    }

    if (this.options.source) {
      settings.aaData = this.options.source;
    }

    if (this.options.serverSide) {
      settings.bServerSide = this.options.serverSide;
    }

    if (this.options.ajaxSource) {
      settings.sAjaxSource = this.options.ajaxSource;
      settings.fnInitComplete = initComplete;
    }

    if (this.options.ajax) {
      settings.ajax = this.options.ajax;
      settings.fnInitComplete = initComplete;
    }

    if (this.options.fixed) {
      settings.sScrollX = '100%';
      settings.bScrollCollapse = true;
    } else {
      settings.bAutoWidth = false;
    }

    if (this.options.createdRow) {
      settings.createdRow = this.options.createdRow;
    }

    if (this.options.rowCallback) {
      settings.rowCallback = this.options.rowCallback;
    }

    if (this.options.autoWidth !== undefined) {
      settings.bAutoWidth = this.options.autoWidth;
    }

    defaultOptions = [
      'oLanguage',
      'aoColumnDefs',
      'fnRowCallback',
      'fnHeaderCallback',
      'scrollX',
    ];
    for (i in defaultOptions) {
      if (this.options[defaultOptions[i]]) {
        settings[defaultOptions[i]] = this.options[defaultOptions[i]];
      }
    }

    // TODO: remove fnDrawCallback option from dataTable options after _drawCallback() is deleted
    // settings.fnDrawCallback = this._drawCallback.bind(this)

    return settings;
  }

  destroy() {
    var api = new jQuery.fn.dataTable.Api(this.table.fnSettings());

    api.destroy();
  }

  fetch(url) {
    var api = new jQuery.fn.dataTable.Api(this.table.fnSettings());

    api.ajax.url(url).load();
  }

  /**
   * Callback executed when the data is initialized and fully loaded.
   * @param {DataTables.Settings} tableSettings - DataTable settings objects
   * @param {object} [json] - JSON data retrieved from the server if ajax option set
   */
  _initComplete(tableSettings) {
    Events.setMaxListeners(0);
    if (this.options.title) {
      this._initTitles();
      this._initClickAction(tableSettings);
    }

    if (this.options.toggleColumns) {
      this._hideEmptyColumns();
      this._initToggleColumns();
    }

    if (this.options.serverSide) {
      // adds tooltip to search input
      this.$el
        .closest('.datatables-container')
        .find('.dataTables_filter input')
        .addClass('has-tip-form')
        .prop('title', 'Press enter to submit');
    }

    this._attachEvents();
    this._initEditable();
    this._initClickOverFixedColumn();

    // remove event handlers from search field
    this.$el
      .closest('.datatables-container')
      .find('.dataTables_filter input')
      .off();
    // attach event handler on keyup to search input that submits search on enter
    this.$el
      .closest('.datatables-container')
      .find('.dataTables_filter input')
      .on('keyup', (e) => {
        if (e.keyCode == 13) {
          this.table.fnFilter(e.currentTarget.value);
        } // deprecated call search()
      });

    // If searchElem passed, attach events
    if (this.options.searchElem) {
      this.options.searchElem = $(this.options.searchElem);
      if (this.options.searchElem.length == 0) {
        console.log(
          'Filter element not found: ' + this.options.searchElem.selector,
        );
      }
      // Attach on keyup handler that submits search on enter
      else {
        this.options.searchElem.on('keyup', (e) => {
          if (e.keyCode == 13) {
            this.table.fnFilter(this.options.searchElem[0].value);
          }
        });
      }

      if (this.options.searchWhen) {
        // Attach handler that listens to searchWhen event and submits search
        Events.on(this.options.searchWhen, () => {
          this.table.fnFilter(this.options.searchElem[0].value);
        });
      }
    }
  }

  /**
   * Attaches event handlers two onChange handlers to elements with row-checkbox class and
   * header-row-checkbox class. And a handler to clear state on beforeunload event
   */
  _attachEvents() {
    this.$el
      .closest('.dataTables_wrapper')
      .on('change', '.row-checkbox', this._handleCheckboxChange.bind(this));
    this.$el
      .closest('.dataTables_wrapper')
      .on(
        'change',
        '.header-row-checkbox',
        this._handleHeaderCheckboxChange.bind(this),
      );
    window.addEventListener('beforeunload', () => {
      this.table.api().state.clear();
    });
  }

  /**
   * Handler for .row-checkbox element.
   * Adds row_selected if checkbox checked and emits dataTables:row-selected
   * events with the list of checked rows
   * @param {event} e jQuery event object
   */
  _handleCheckboxChange(e) {
    var $dynamicColumns = this.$el.find('tbody'),
      $leftRow = $(e.currentTarget).closest('tr'),
      $wrapper = this.$el.closest('.dataTables_wrapper'),
      index,
      $rightRow;

    index = this._getChildIndex($leftRow.parent(), $leftRow[0]);
    $rightRow = $dynamicColumns.find('tr:eq(' + index + ')');
    $leftRow.toggleClass('row_selected', e.target.checked);
    $rightRow.toggleClass('row_selected', e.target.checked);

    this.trigger(
      'dataTables:row-selected',
      $wrapper.find('.row-checkbox:checked'),
    );
  }

  /**
   * Handler for .header-row-checkbox element.
   * Selects all rows and trigger change event
   * Emits dataTables:header-row-selected event
   * @param {event} e jQuery event object
   * @todo check if this is used by anyone
   */
  _handleHeaderCheckboxChange(e) {
    var $wrapper = this.$el.closest('.dataTables_wrapper'),
      checkableRows = $wrapper.find('.row-checkbox'),
      i;

    for (i = checkableRows.length - 1; i >= 0; i--) {
      checkableRows[i].checked = e.target.checked;

      $checkableRow = $(checkableRows[i]);
      $checkableRow.trigger('change');

      if (e.target.checked === true) {
        $checkableRow.next().addClass('checked');
      } else {
        $checkableRow.next().removeClass('checked');
      }
    }

    this.trigger(
      'dataTables:header-row-selected',
      $wrapper.find('.header-row-checkbox:checked'),
    );
  }

  /**
   * @todo Remove unused function
   */
  _fixedColumnsCallback() {
    this._adjustHover();
    this._adjustRowsHeight();
  }

  /**
   * Callback passed to DataTable's drawCallback, which is called on
   * every draw. It manipulates the following data: password and truncates columns
   * @todo remove this in the next major version
   */
  _drawCallback() {
    if (!this.table || this._drawCallbackCalled) {
      return;
    }
    this._drawCallbackCalled = true; // to avoid loop
    // TODO: The work done by _hidePasswords() was replaced by calling maskPassword() inside
    //    dataTable's callback createdRow. As for _truncateColumn, it's only used by firewall_rules
    //    for a column that is no longer displayed.
    // this._transformStatusColumns()
    // this._hidePasswords()
    // this._truncateColumn()
    // this._drawCallbackCalled = false
  }

  /**
   * Adds title attribute, which is shown as a tooltip text
   * the value is set in the options object
   */
  _initTitles() {
    var $nodes = $(this.table.fnGetNodes());

    $nodes.attr('title', this.options.title);
  }

  /**
   * List for onClick event in table rows. Add callback handler that will depend
   * will depend on the row type.
   * This function is called if row has attr title
   * @param {DataTables.Settings} tableSettings - DataTable settings objects
   */
  _initClickAction(tableSettings) {
    var self = this,
      pos,
      data,
      page,
      controller,
      url;

    tableSettings = tableSettings || this.table.fnSettings();
    this.$el.on('click', 'tr', function (e) {
      // If row has input, callback handler will select/unselect checkbox.
      if (
        e.target.tagName.toLowerCase() == 'input' &&
        $(e.target).attr('type') == 'checkbox'
      ) {
        var el = $($(this).find('form.custom').html());

        el.prop('checked')
          ? el.prop('checked', false)
          : el.prop('checked', true);
        // If row has href attribute, handler calls Turbolinks.visit for href link
      } else if ($(e.target).attr('href')) {
        Turbolinks.visit($(e.target).attr('href'));
      }

      // Finally, if no href or editing, handler will generate url and call Turbolinks.visit.
      else if (
        (!self.options.editable || !self.$el.closest('.editing').length) &&
        (e.isTrigger || e.originalEvent.detail === 1 || ie === 8)
      ) {
        pos = self.table.fnGetPosition(this);
        if (typeof pos !== 'number') {
          return;
        }

        data = tableSettings.aoData[pos]._aData;
        data = data[data.length - 1];
        page = parseInt($('.paginate_active').text()) - 1;
        cookie.set('currentPage', page.toString());

        const hasCustomer = self.options.controller
          .split('/')
          .some((v) => v.toLowerCase() === currentCustomer.toLowerCase());

        controller = hasCustomer
          ? self.options.controller
          : currentCustomer + '/' + self.options.controller;
        url =
          data[0] === '/'
            ? data
            : '//' + document.location.host + '/' + controller + '/' + data;
        Turbolinks.visit(url);
      }
    });
  }

  /**
   * Hides column if all column's rows are empty, and adjust layout.
   */
  _hideEmptyColumns() {
    var columns = this.options.columns || [],
      data = this.table.fnGetData(), // table's data (deprecated function. call getData())
      emptyColumn = null,
      emptyString = null,
      i,
      j;

    for (i = 0, columnLength = columns.length; i < columnLength; i++) {
      emptyColumn = true;

      for (j = 0, rowLength = data.length; j < rowLength; j++) {
        emptyString = data[j][i].toString().length === 0;

        if (!emptyString) {
          emptyColumn = false;
          break;
        }
      }

      this.options.columns[i].empty = emptyColumn;
      if (emptyColumn) {
        this.table.fnSetColumnVis(i, false, false);
      } // set column visibility (deprecated function. call visible())
    }
    this._adjustColumnSizing();
    this._adjustRowsHeight();
  }

  /**
   * @todo Remove this function. This is never used. It was introduced
   *    in 2013 for firewall policies and it's no longer used by anyone.
   */
  _initToggleColumns() {
    var columnsHTML = '<dl class="sub-nav columns">' + '<dt>Columns:</dt>',
      columns = this.options.columns,
      $dataTablesWrapper = this.$el.closest('.dataTables_wrapper'),
      i,
      notId,
      notFirstAndFixed,
      active;

    for (i = 0; i < columns.length; i++) {
      notId = columns[i].sTitle !== 'id';
      notFirstAndFixed = this.options.fixed && i !== 0;
      active = null;

      if (notId && notFirstAndFixed) {
        active = columns[i].empty ? '' : ' active';
        columnsHTML +=
          '<dd class="sub-nav-item' +
          active +
          '" data-index="' +
          i +
          '"><a href="#">' +
          columns[i].sTitle +
          '</a></dd>';
      }
    }
    columnsHTML += '</dl>';
    $dataTablesWrapper.prepend(columnsHTML);

    this._attachToggleColumnsEvents(
      $dataTablesWrapper.find('.sub-nav'),
      this.table,
    );
  }

  /**
   * @todo Remove this function.
   */
  _attachToggleColumnsEvents($subNav, table) {
    var $el, col, visible;

    $subNav.on('click', '.sub-nav-item', (e) => {
      $el = $(e.currentTarget);

      e.preventDefault();
      col = $el.data('index');
      $el.toggleClass('active');
      visible = table.fnSettings().aoColumns[col].bVisible;
      table.fnSetColumnVis(col, !visible);
      this._truncateColumn();
    });
  }

  /**
   * Add span element for sensu status column by checking columns's pType
   * calls fnAdjustColumnSizing()
   * @todo Remove this hacky implementation in favor of an implementation that takes
   *    advantage of dataTable's columns.render option
   * @see IO.Views.Nodes.New
   * @see https://datatables.net/reference/option/columns.render
   */
  _transformStatusColumns() {
    var columns = this.options.columns,
      length = columns.length,
      index = 0,
      $rows = this.$el.find('tr'),
      self = this,
      nodeStatus,
      nodeOnline,
      nodeStatusInt;

    $rows = self.$el.find('tr');
    for (; index < length; index += 1) {
      if (columns[index].pType === 'sensu_status') {
        $.each(
          $rows.find('td:nth-child(' + (index + 1) + ')'),
          function (i, td) {
            nodeStatus = td.innerHTML;
            nodeOnline = nodeStatus === 'online';
            nodeStatusInt = nodeOnline ? 1 : 0;

            td.innerHTML =
              '<span class="ir sensu-status sensu-status-12px sensu-status-datatables sensu-status-' +
              nodeStatus +
              ' title="' +
              nodeStatus +
              '">' +
              nodeStatusInt +
              '</span>';
          },
        );
      }
    }

    this.table.fnAdjustColumnSizing();
  }

  /**
   * Masks passwords using RPM's jquery plugin
   * calls fnAdjustColumnSizing()
   * @see jquery.password.js
   * @todo remove this in the next major version since initialization of maskPassword() plugin
   *    is now being done by dataTable's createdRow callback (simpler implementation)
   */
  _hidePasswords() {
    var columns = this.options.columns || [],
      length = columns.length,
      index = 0,
      $rows = this.$el.find('tr'),
      self = this;

    $rows = self.$el.find('tr');
    // Loop over all columns to search for password type.
    for (; index < length; index += 1) {
      if (columns[index].pType === 'password') {
        $rows
          .find('td:nth-child(' + (index + 1) + ')')
          .addClass('mask-password');
      }
    }

    $('.mask-password').maskPassword();
    this.table.fnAdjustColumnSizing();
  }

  _getTruncatableColumnIndexes() {
    var $dataTablesWrapper = this.$el.closest('.dataTables_wrapper'),
      truncatableColumns = this.options.truncatableColumns,
      output = [],
      columnName;

    $dataTablesWrapper
      .find('.dataTables_scrollHeadInner th')
      .each(function (index, column) {
        columnName = $(column).text();
        if (truncatableColumns.indexOf(columnName) !== -1) {
          output.push(index);
        }
      });

    return output;
  }

  /**
   * Truncates text in columns passed by truncatableColumns
   * calls _adjustColumnSizing, _adjustRowsHeight and _adjustHover
   * @todo Check if this is still useful given that only firewall-rules
   *    defines truncatableColumns option. There seems to be a better solution
   *    suggested by dataTable's blog.
   * @see https://datatables.net/blog/2016-02-26#Reusable-renderers
   */
  _truncateColumn() {
    var $rows = this.table.$('tr:visible'),
      columnIndexes,
      i,
      $div;

    if (!this.options.truncatableColumns) {
      return;
    }

    columnIndexes = this._getTruncatableColumnIndexes();
    for (i = 0, len = columnIndexes.length; i < len; i++) {
      $div = $(
        "<div style=\"display:none;font-size:11px;font-family: 'Helvetica Neue', Helvetica," +
          ' Helvetica, Arial, sans-serif;"></div>',
      ).appendTo('body');

      $rows.each(function (index, row) {
        var $row, $column, columnWidth, textWidth, text;

        // just getting info
        $row = $(row);
        $column = $row.find('td:eq(' + columnIndexes[i] + ')');
        columnWidth = $column.width() - 20; // 20px = padding

        if (!$column.data('original')) {
          $column.data('original', $column.text());
        }

        text = $column.data('original') || $column.text();
        $div.text(text);
        textWidth = $div.width();

        // it actually truncates below
        if (textWidth >= columnWidth) {
          $column.attr('title', text);
          $row.css('height', 'auto');

          while (textWidth > columnWidth) {
            text = text.substr(0, text.length - 1).trim();
            $div.text(text + '...');
            textWidth = $div.width();
          }
          $column.text(text + '...');
        } else {
          $column.text(text);
        }
      });

      $div.remove();
    }

    this._adjustColumnSizing();
    this._adjustRowsHeight();
    this._adjustHover();
  }

  /**
   * Adjust column size.
   * According to documentation this function should be called when the
   * table is hidden when initialized or when data changes significantly.
   * @todo Remove access to datatables private settings object and
   *    deprecated properties.
   */
  _adjustColumnSizing() {
    var ajaxDataGet = this.table.dataTableSettings[0].bAjaxDataGet; // deprecated property used as lock on draw

    this.table.dataTableSettings[0].bAjaxDataGet = false;
    this.table.fnAdjustColumnSizing();
    this.table.dataTableSettings[0].bAjaxDataGet = ajaxDataGet;
  }

  /**
   *  Adjust rows height via css
   */
  _adjustRowsHeight() {
    var $dynamicRows = this.$el.find('tr'),
      $fixedColumn = $('.DTFC_LeftBodyWrapper'),
      $rows = this.table.$('tr:visible'),
      $fixedRow;

    $rows.css('height', 'auto');

    $dynamicRows.each(function (index, row) {
      $fixedRow = $fixedColumn.find('tr:eq(' + index + ')');
      $fixedRow.css('height', $(row).height() + 1 + 'px');

      if (typeof ie !== 'undefined') {
        $fixedRow.find('td').css('height', $(row).height() + 1 + 'px');
      }
    });
  }

  /**
   * Attach mouseover and mouseout event handlers
   * that add highlighted class
   */
  _adjustHover() {
    var $dynamicColumns = this.$el.find('tbody'),
      $fixedColumn = $('.DTFC_LeftBodyWrapper'),
      self = this;

    // part 1 - hover over the dynamic columns
    $dynamicColumns.on('mouseover', 'tr', function () {
      var index, $row;

      index = self._getChildIndex($(this).parent(), this);
      $row = $fixedColumn.find('tbody').find('tr:eq(' + index + ')');
      $row.addClass('highlighted');
    });

    $dynamicColumns.on('mouseout', 'tr', function () {
      $fixedColumn.find('.highlighted').removeClass('highlighted');
    });

    // part 2 - hover over the fixed column
    $fixedColumn.on('mouseover', 'tr', function () {
      var index, $row;

      index = self._getChildIndex($(this).parent(), this);
      $(this).addClass('highlighted');
      $row = $dynamicColumns.find('tr:eq(' + index + ')');
      $row.addClass('highlighted');
    });

    $fixedColumn.on('mouseout', 'tr', function () {
      $(this).removeClass('highlighted');
      $dynamicColumns.find('.highlighted').removeClass('highlighted');
    });
  }

  // this was necessary to make datatables rows compatible with ContentEditable
  // from the content editable component
  _initEditable() {
    var self = this,
      $nodes = $(this.table.fnGetNodes());

    if (!this.options.editable) {
      return;
    }

    $nodes.each(function (index, node) {
      var $node, pos, data, tableSettings;

      pos = self.table.fnGetPosition(node);
      tableSettings = self.table.fnSettings();
      data = tableSettings.aoData[pos]._aData;
      $node = $(node);
      $node.addClass('editable no-border');
      $node.data('success', 'custom');
      $node.data('targetName', 'edit-rule-' + data[data.length - 1]);
      $node.data(
        'fallback',
        '/' + self.options.controller + '/' + data[data.length - 1] + '/edit',
      );
    });
  }

  reload() {
    if (!this.table) {
      return;
    }
    try {
      this.table._fnAjaxUpdate();
    } catch (e) {
      console.warn('Table not ready:', e);
    }
  }

  /**
   * @todo Remove if we don't use fixed columns
   */
  _initClickOverFixedColumn() {
    var $dynamicColumns = this.$el.find('tbody'),
      $fixedColumn = $('.DTFC_LeftBodyWrapper').find('table'),
      self = this;

    $fixedColumn.on('tr', 'click', function (e) {
      var target = e.target,
        index,
        $row;

      if (target.tagName !== 'TR' && target.tagName !== 'TD') {
        return;
      }

      index = self._getChildIndex($(target).parent(), target);
      $row = $dynamicColumns.find('tr:eq(' + index + ')');
      $row.trigger('click');
    });
  }

  /**
   * Internal helper function
   */
  _getChildIndex($parent, child) {
    var output;

    $parent.children().each(function (index, value) {
      if (value === child) {
        output = index;
        return false;
      }
    });
    return output;
  }
}
